import { useEffect, type ReactNode } from 'react'
import DhtnLogo from './DhtnLogo'
import PaintedHeadline from './PaintedHeadline'
import { useInterfaceLanguage } from '../../i18n/useInterfaceLanguage'
import { systemCopy } from '../../i18n/systemCopy'
import './RecoveryShell.css'

/** Every error and info page (founder, 7 Oct 2026): one painting, one sentence, one button. No icons. */
export default function RecoveryShell({ title, headline, sentence, children }: {
    /** The page's one sentence (and the tab title). */
    title: string
    /** Two or three words, painted on one line as the page's picture (founder, 9 Oct 2026). */
    headline?: string
    /** The plain sentence under the headline; the title when not given. */
    sentence?: string
    children: ReactNode
}) {
    const language = useInterfaceLanguage()
    useEffect(() => {
        const previousTitle = document.title
        document.title = `${title} — DHTN Academy`
        return () => { document.title = previousTitle }
    }, [title])
    return <div className="recovery-shell" lang={language} dir={language === 'ar' ? 'rtl' : 'ltr'}>
        <header data-page-width className="recovery-header dhtn-page">
            <a href="/" aria-label={systemCopy[language].homeLabel} className="recovery-brand">
                <DhtnLogo variant="symbol" shine="rest" className="recovery-logo" />
            </a>
        </header>
        <main data-page-width className="recovery-main dhtn-page">
            <div className={`recovery-content${headline ? ' is-painted' : ''}`}>
                {headline ? <><PaintedHeadline text={headline} /><p className="recovery-sentence">{sentence ?? title}</p></> : <h1>{title}</h1>}
                <div className="recovery-actions">{children}</div>
            </div>
        </main>
    </div>
}
